import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { OverlayApp } from './OverlayApp';
import { WidgetApp } from './WidgetApp';
import './styles/animations.css';
import './styles/games.css';

const path = window.location.pathname;
const widgetMatch = /^\/w\/([a-z0-9_-]+)\/?$/i.exec(path);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {widgetMatch ? <WidgetApp widgetType={widgetMatch[1]!} /> : <OverlayApp />}
  </StrictMode>,
);
